import { useAuth } from '../contexts/AuthContext'
import { useTheme } from '../contexts/ThemeContext'
import { useNavigate } from 'react-router-dom'
import { getSelectedEnvironment, setSelectedEnvironment } from '../api/client'
import { useState } from 'react'

export default function GlobalHeader() {
    const { theme, setTheme } = useTheme()
    const { isAuthenticated, signOut, user } = useAuth()
    const navigate = useNavigate()
    const [env, setEnv] = useState<'prod' | 'dev'>(getSelectedEnvironment())

    const toggleTheme = () => {
        setTheme(theme === 'light' ? 'dark' : 'light')
    }

    const getThemeIcon = () => {
        return theme === 'dark' ? '🌙' : '☀️'
    }

    const handleEnvChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newEnv = e.target.value as 'prod' | 'dev'
        if (newEnv === env) return
        const confirmChange = window.confirm(
            `Switching to ${newEnv === 'prod' ? 'Production' : 'Development'} environment will log you out of your current session. Do you want to proceed?`
        )
        if (confirmChange) {
            setSelectedEnvironment(newEnv)
            setEnv(newEnv)
            window.location.href = '/login'
        }
    }

    return (
        <header className="header" style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 1.5rem',
            height: '70px',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            transition: 'all 0.3s ease'
        }}>
            <div
                onClick={() => isAuthenticated ? navigate('/') : navigate('/login')}
                className="logo-container"
                style={{ cursor: 'pointer' }}
            >
                <img
                    src="https://pocketcastorage.blob.core.windows.net/payvizio-public/PayVizio_Logo.png"
                    alt="PayVizio Logo"
                    className="logo-img"
                />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
                {/* Environment Switcher */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span className="hidden-mobile" style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Server:</span>
                    <select
                        value={env}
                        onChange={handleEnvChange}
                        className="env-selector"
                        style={{
                            background: 'var(--bg-secondary)',
                            border: '1px solid var(--border)',
                            color: 'var(--text)',
                            padding: '0.4rem 0.8rem',
                            borderRadius: '8px',
                            fontSize: '0.85rem',
                            fontWeight: 600,
                            cursor: 'pointer',
                            outline: 'none',
                            transition: 'all 0.2s ease',
                            boxShadow: 'var(--shadow)'
                        }}
                    >
                        <option value="prod">🟢 Production</option>
                        <option value="dev">🟡 Development</option>
                    </select>
                </div>

                {/* 2-State Toggle Switch */}
                <div
                    className="theme-switch"
                    onClick={toggleTheme}
                    title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
                    role="switch"
                    aria-checked={theme === 'dark'}
                >
                    <div className="theme-switch-knob">
                        <span className="theme-icon">{getThemeIcon()}</span>
                    </div>
                </div>

                {isAuthenticated && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <span className="hidden-mobile" style={{ fontSize: '0.9rem', color: 'var(--text)', fontWeight: 600 }}>
                            {user?.fullName || 'Admin'}
                        </span>
                        <button
                            className="btn logout"
                            onClick={signOut}
                            style={{ fontSize: '0.85rem', padding: '0.4rem 0.8rem' }}
                        >
                            Logout
                        </button>
                    </div>
                )}
            </div>
        </header>
    )
}
